module.exports = __webpack_public_path__ + "static/antidote-7dbb669ea0fada80aa6b150a7f345cc8.png";